import { Component, OnInit, Inject, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { FormBuilder, Validators, FormGroup, NgForm } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { ManikEntityFE, CookieManager } from 'src/app/manik-library/ManikEntityFE';
import { GrabADealModel } from 'src/app/models/web-card-model';
import { ManikEntityService } from 'src/app/manik-library/ManikEntityService';

declare const grecaptcha: any;

declare const $: any;
@Component({
  selector: 'get-a-deal',
  templateUrl: './grab-adeal.component.html',
  styleUrls: ['./grab-adeal.component.scss']
})
export class GrabADealComponent extends ManikEntityFE implements OnInit, OnChanges {
  GetADealForm: FormGroup;
  GDModel: GrabADealModel = new GrabADealModel();
  EnquiryRecaptcha: any;
  CaptchaInvalid: boolean = false;
  CaptchaMessage: string = '';
  WebSiteMetaData: any = {};
  UserLoggedIn: boolean;
  @Input() VisitorData: any;
  @Output() VisitorLoggedIn = new EventEmitter();
  ContactModeList: any[] = [];
  TimeRangeList: any[] = [];
  CaptchaInitialized: boolean = false;
  ShowButton=true;
  constructor(public httpClient: HttpClient, public _routeParams: ActivatedRoute,private formBuilder: FormBuilder, public _manikEntityService: ManikEntityService, @Inject(DOCUMENT) public document: any) {
    super(document);
    this.GetADealForm = this.formBuilder.group({
      PreferredContactMode: ['', Validators.required],
      BestTimeToCall: ['', Validators.required],
      Remarks: ['', Validators.required],
      LocationOfService: [''],
      DesiredBudget: [''],
      RequestedServiceDate: [''],
      VisitorID: ['']
    });
  }

  ngOnInit() {
    this.httpClient.get("https://cors-anywhere.herokuapp.com/https://api.ipify.org/?format=json").subscribe((res:any)=>{
      let ipAddress = res.ip;
    });

    // https://cors-anywhere.herokuapp.com/http://api.ipify.org/?format=text

    this.ShowButton=true;
    this.WebSiteMetaData = JSON.parse(sessionStorage.getItem("SiteMetaData"));
   console.log(this.WebSiteMetaData)
      this.CheckUserLoggedIn();
   this.populateControls()
   sessionStorage.setItem("ShowButton",'true')
  //   this.ShowButton = sessionStorage.getItem("ShowButton")=='true'
    // console.log(this.ShowButton,sessionStorage.getItem("ShowButton"))
  }

  ngOnChanges() {
    this.CheckUserLoggedIn();
    this.ShowButton = sessionStorage.getItem("ShowButton")=='true';
    // console.log(this.ShowButton,CookieManager.getCookie('ShowButton'))
  }
  ngDoCheck(){
    this.ShowButton = sessionStorage.getItem("ShowButton")=='true'?true:false;
    // console.log(this.ShowButton,CookieManager.getCookie('ShowButton'))
  }
  CheckUserLoggedIn() {
    if (CookieManager.getCookie('VisitorData')) {
      let x = JSON.parse(CookieManager.getCookie('VisitorData'));
      if (x) {
        if (x.VisitorName) {
          this.UserLoggedIn = true;
          this.GetADealForm.controls['VisitorID'].setValue(x.VisitorID);
          setTimeout(() => {
            if (!this.CaptchaInitialized) {
              this.InitCaptcha(this.EnquiryRecaptcha, 'enquiryForm', grecaptcha);
              this.CaptchaInitialized = true;
            }
          }, 1000);
        }
        else {
          this.UserLoggedIn = false;
        }
      }
      else {
        this.UserLoggedIn = false;
      }
    }
  }


  Emit() {
    this.VisitorLoggedIn.emit('Y');  
  }

  populateControls(): void {
    this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", null, this.prepareAddlQueryHeaders2("ULTRA.QUICK", "GET.CONTACT.PREFERENCES", "PORTAL"))
    .subscribe(data => {
      this.ContactModeList = data.ManikJSon[0].JSon0;
      this.TimeRangeList = data.ManikJSon[0].JSon1;
      console.log(this.ContactModeList)
    })
  }
   refreshDataGrid(param: any): void {
  }

  SubmitCallMeBack() {
    if (this.GetADealForm.invalid) {
      return;
    }
    this.CaptchaInvalid = false;
    this.CaptchaMessage = '';
    let x = grecaptcha.getResponse(this.EnquiryRecaptcha);
    this._manikEntityService.manikEntityConnect2('WebSite/captcha/v2?sToken=' + x, null, null)
      .subscribe(data => {
        if (data.success) {
          this.SubmitForm();
        }
        else {
          this.CaptchaInvalid = true;
          if (data['error-codes'].find(item => {
            return item == 'missing-input-response'
          })) {
            this.CaptchaMessage = 'Please click on the checkbox';
          }
          if (data['error-codes'].find(item => {
            return item == 'timeout-or-duplicate'
          })) {
            this.CaptchaMessage = 'Please click on the checkbox again';
          }
        }
      });

  }

  SubmitForm() {
    if (this.GetADealForm.invalid) {
      return;
    }
    console.log(this.GetADealForm.value)
    this.FormSubmitted = true;
    this.GDModel.IsSubmitted=true;
    let body = this.GetADealForm.value;
    body['PortalID'] = this.WebSiteMetaData.PID;
    let idlist = this.WebSiteMetaData.EC.split('_');
    body['CountryID'] = idlist[0];
    body['CityID'] = idlist[1];
    body['LocalityID'] = idlist[2];
    body['CategoryID'] = idlist[3];
    body['SubCategoryID'] = idlist[4];
    // this.httpClient.get<{ip:string}>('https://ipapi.co/json')
    this.httpClient.get("https://cors-anywhere.herokuapp.com/https://api.ipify.org/?format=json")
    .subscribe( data => {
     
    // this._manikEntityService.manikGetMyIPAddress()
     
        body["IPAddress"] = data['ip'];
        let SubmittedData = JSON.stringify({ "items": [body] });
        this._manikEntityService.manikEntityConnect2(this.EndPoint+"entitymgr", SubmittedData,
          this.prepareManageHeaders2("A", "MANIKAD.LEADS", "MANIK.GLOBAL"))
          .subscribe(data => {
            this.FormSubmitted = false;
            this.GDModel.IsSubmitted=false;
            $("#lblGMessage").text("Your request has been submitted!");
            $("#lblGMessage").show();
            // $("#lblGMessage").hide();
            setTimeout(() => {
              $("#lblGMessage").hide();
              $('#GenerateLead').modal('hide');
              this.GetADealForm.reset()
            }, 2000);
          }, error => {
            console.log(error)
          });
      });
    
  }
  close(){
    this.GetADealForm.reset()
  }
  get dForm() {
    return this.GetADealForm.controls;
  }
}
